import { Box, Typography, Grid, useMediaQuery, useTheme } from '@mui/material';

export interface ProjectIdeaBoxProps {
  imageUrl: string;
  title?: string;
  descriptionHtml: string;
}

export const ProjectIdeaBox = ({ imageUrl, title, descriptionHtml }: ProjectIdeaBoxProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box sx={{ borderRadius: '20px', overflow: 'hidden' }}>
      <Grid
        container
        spacing={0}
        direction={isDesktop ? 'row' : 'column'}
        alignItems={isDesktop ? 'stretch' : 'center'}
      >
        {/* image */}
        {imageUrl && (
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              order: 1,
              width: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: { xs: 220, md: 400 },
                overflow: 'hidden',
                bgcolor: '#ddd',
              }}
            >
              <img
                src={imageUrl}
                alt={title || ''}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </Box>
          </Grid>
        )}

        {/* infomation */}
        <Grid
          item
          xs={12}
          md={imageUrl ? 6 : 12}
          sx={{
            order: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: isDesktop ? 'center' : 'flex-start',
            alignItems: isDesktop ? 'flex-start' : 'center',
            width: '100%',
            bgcolor: '#F5F5F6',
            height: { xs: 220, md: 400 },
          }}
        >
          <Box
            sx={{
              boxShadow: 0,
              width: '100%',
              height: { xs: 220, md: 400 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              textAlign: 'left',
              overflowY: 'auto',
              px: { xs: 2, md: 3 },
              my: { xs: 2, md: 4 },
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            {title && (
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#222' }} gutterBottom>
                {title}
              </Typography>
            )}
            <Box
              className="rich-content"
              sx={{
                color: '#575758',
                fontSize: '0.875rem',
                width: '100%',
              }}
              dangerouslySetInnerHTML={{
                __html: descriptionHtml.replace(/(?:\r\n|\r|\n)/g, '<br/>'),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
